module.exports = __webpack_public_path__ + "static/pic01-c86e81636e3794079c10c423d525472d.jpg";